import { render, staticRenderFns } from "./setting_center.vue?vue&type=template&id=aaac30d4&"
import script from "./setting_center.vue?vue&type=script&lang=js&"
export * from "./setting_center.vue?vue&type=script&lang=js&"
import style0 from "./setting_center.vue?vue&type=style&index=0&id=aaac30d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports